import { openHtmlDocument } from "./docViewer";
import { formatCurrency } from "./utils";
import { barcodeSvg } from "./barcode";

const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

// Folha A4 de etiquetas (3 colunas × 8 linhas = 24 por página; 63,5×33,9mm ≈ formato de etiquetas autocolantes comum)
export const printBarcodeLabels = (products, settings = {}, { copies = 1, showPrice = true } = {}) => {
  const items = products.filter((p) => p.barcode).flatMap((p) => Array.from({ length: Math.max(1, Number(copies) || 1) }, () => p));
  if (!items.length) return false;
  const cells = items
    .map((p) => `<div class="lbl"><div class="n">${esc(p.name)}</div>${showPrice ? `<div class="p">${formatCurrency(p.price)}</div>` : ""}<div class="bc">${barcodeSvg(p.barcode, { height: 34, width: 1.6, fontSize: 11 })}</div></div>`)
    .join("");
  const html = `<!DOCTYPE html><html lang="pt"><head><meta charset="utf-8"><title>Etiquetas de código de barras</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}@page{size:A4;margin:8mm 6mm}
body{font-family:Arial,Helvetica,sans-serif;color:#000;background:#fff}
.sheet{display:grid;grid-template-columns:repeat(3,63.5mm);grid-auto-rows:33.9mm;gap:0 2.5mm;justify-content:center}
.lbl{border:1px dashed #ccc;padding:1.5mm 2mm;display:flex;flex-direction:column;align-items:center;justify-content:space-between;overflow:hidden;break-inside:avoid}
.n{font-size:10px;font-weight:700;text-align:center;line-height:1.15;max-height:2.3em;overflow:hidden}
.p{font-size:12px;font-weight:900}
.bc svg{max-width:58mm;height:auto}
.hd{font-size:11px;color:#666;margin-bottom:3mm;display:flex;justify-content:space-between}
@media print{.hd{display:none}.lbl{border-color:transparent}}
</style></head><body>
<div class="hd"><span>${esc(settings.restaurant_name || "")} · ${items.length} etiqueta(s)</span><span>Papel A4 · 3×8 (63,5×33,9 mm)</span></div>
<div class="sheet">${cells}</div>
<script>window.onload=function(){setTimeout(function(){window.print()},400)}</script>
</body></html>`;
  openHtmlDocument(html, { title: "Etiquetas" });
  return true;
};
